import { AppFrame } from "@onlinetools/ui";

export function PrivacyPolicy() {
  return (
    <AppFrame title="Privacy Policy">
      <title>Privacy Policy - Any Tool Online</title>
      <meta
        content="Any Tool Online does not store or log files you submit. Learn how we handle data."
        name="description"
      />
      <article className="prose-page">
        <p className="eyebrow">Last updated May 2026</p>

        <section>
          <h2>The short version</h2>
          <p>
            Any Tool Online does not store, log, or share any file or text you submit. Everything
            is processed in memory and discarded the moment your result is returned. No account is
            required. No content ever leaves the server in a form that is linked to you.
          </p>
        </section>

        <section>
          <h2>What we collect</h2>
          <p>
            We collect nothing beyond what is strictly necessary to serve the request. Your IP
            address is used transiently for rate limiting - a per-minute counter that resets
            automatically and is never written to disk or stored anywhere persistent.
          </p>
          <p>
            We do not collect names, email addresses, or any personally identifying information.
          </p>
        </section>

        <section>
          <h2>Your files and input</h2>
          <p>
            Files and text you upload or enter are processed entirely in server memory to produce
            your result. They are not saved to disk, not logged, not forwarded to any third party,
            and not retained after the response is sent. There is no database. There is no storage
            layer.
          </p>
        </section>

        <section>
          <h2>Third-party services</h2>
          <p>
            <strong>Google Analytics</strong> - We use Google Analytics to collect aggregated,
            anonymous traffic data (page views, general geography, device type). This does not
            include any of your file content or inputs. Google&#39;s{" "}
            <a
              href="https://policies.google.com/privacy"
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Policy
            </a>{" "}
            applies.
          </p>
          <p>
            <strong>Google AdSense</strong> - We display ads served by Google AdSense. Google
            may use cookies to serve ads based on your prior visits to this or other websites.
            You can opt out via{" "}
            <a
              href="https://www.google.com/settings/ads"
              rel="noopener noreferrer"
              target="_blank"
            >
              Google&#39;s ad settings
            </a>
            .
          </p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            Any Tool Online itself sets no cookies. Google Analytics and Google AdSense may set
            their own cookies as described in Google&#39;s privacy policy linked above.
          </p>
        </section>

        <section>
          <h2>Changes</h2>
          <p>
            We may update this policy from time to time. The date at the top of this page reflects
            the most recent revision.
          </p>
        </section>
      </article>
    </AppFrame>
  );
}
